import React, { useEffect, useRef } from 'react';
import { SectionWrapper } from './Shared';
import { BookOpen } from 'lucide-react';
declare global {
  interface Window {
    fbq: any;
  }
}
export const Offer = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const hasFired = useRef(false);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !hasFired.current) {
          hasFired.current = true;
          if (window.fbq) {
            window.fbq('track', 'ViewContent', {
              content_name: 'The Prime Architect PDF',
              content_category: 'eBook',
              currency: 'USD',
              value: 6.39
            });
          }
        }
      });
    }, {
      threshold: 0.3
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => observer.disconnect();
  }, []);
  return <div ref={sectionRef} data-id="element-81">
      <SectionWrapper className="bg-prime-dark border-y border-white/5" data-id="element-82">
        <div className="text-center mb-16" data-id="element-83">
          <p className="text-prime-gold uppercase tracking-widest text-sm font-bold mb-4" data-id="element-84">
            Tu Nuevo Plano Biológico
          </p>
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-85">
            Esto no es solo un ebook.
          </h2>
          <p className="text-xl text-prime-textMuted max-w-2xl mx-auto" data-id="element-86">
            Al unirte hoy a The Prime Architect, recibes:
          </p>
        </div>

        <div className="max-w-4xl mx-auto" data-id="element-87">
          <div className="bg-gradient-to-br from-prime-card to-prime-black border border-prime-gold/50 rounded-xl p-8 shadow-[0_0_30px_rgba(212,168,83,0.1)] relative overflow-hidden" data-id="element-88">
            <div className="absolute top-0 right-0 bg-prime-gold text-prime-black font-bold px-4 py-1 rounded-bl-lg text-sm" data-id="element-89">
              NÚCLEO DEL PROGRAMA
            </div>
            <div className="flex flex-col md:flex-row gap-6 items-center md:items-start" data-id="element-90">
              <div className="bg-prime-black p-4 rounded-full border border-prime-gold/30" data-id="element-91">
                <BookOpen className="w-8 h-8 text-prime-gold" data-id="element-92" />
              </div>
              <div className="flex-grow text-center md:text-left" data-id="element-93">
                <h3 className="text-2xl font-bold text-white mb-2" data-id="element-94">
                  The Prime Architect Main Protocol
                </h3>
                <p className="text-prime-textMuted" data-id="element-95">
                  El sistema completo de 60 páginas para reconstruir tu cuerpo y
                  hormonas.
                </p>
              </div>
              <div className="text-right" data-id="element-96">
                <p className="text-sm text-prime-textMuted uppercase tracking-wider" data-id="element-97">
                  Valor Real
                </p>
                <p className="text-2xl font-serif text-white line-through decoration-prime-red/70 decoration-2" data-id="element-98">
                  $97
                </p>
              </div>
            </div>
          </div>
        </div>
      </SectionWrapper>
    </div>;
};